import React, { Component } from 'react'
import './scss/FacebookLogin.scss';
import FbIconLg from '../../svg/Social/FbIconLg';
import { getEnvVar } from '../../../util/lib';
import { debugLog } from '../../../util/logUtils';

export class FacebookLoginStateless extends Component {

	constructor(props) {
		super(props);
		this.appId = getEnvVar("REACT_APP_FACEBOOK_APP_ID");
		this.scriptUrl = "";
		this.state = {
			sdkLoaded: false,
		}
	}

	//Handle the response from the FB SDK
	responseHandler = (response) => {
		window.FB.logout(() => {
			//logout as soon as the response received. (state less) to avoid auto login based on session.
			debugLog("FB logged out");
		});
		this.props.onAuth(response);
	}

	//Load the FB SDK
	componentDidMount() {
		debugLog("comdidmnt");
		if (document.getElementById("facebook-jssdk")) {
			this.setState({ sdkLoaded: true });
			return;
		}
		window.fbAsyncInit =  () => {
			debugLog("fb init");
			window.FB.init({
				appId: this.appId,
				autoLogAppEvents: true,
				xfbml: true,
				version: 'v11.0'
			});
		};
		this.asyncLoadFbSDK();

	}

	//handler to process the FB.login() and call Fb.api(/me) to get user data
	getUserData = (loginResponse) => { 
		if(loginResponse.status === "connected") { 
			window.FB.api('/me', {fields:'name, email,picture'}, this.responseHandler);
		}else {
			debugLog("App not authorized");
		}
	}

	//load Fb sdk async
	asyncLoadFbSDK = () => {
		(function (docObj, scriptTab, id) {
			var js, fjs = docObj.getElementsByTagName(scriptTab)[0];
			if (docObj.getElementById(id)) return;
			js = docObj.createElement(scriptTab); js.id = id;
			js.src = "//connect.facebook.net/en_US/sdk.js";
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	}

	
	handleOnclickLoginBtn = (e) => {
		e.preventDefault();
		window.FB.login(this.getUserData, { scope: 'email' });
	}

	render() {
		const data = this.props.data || {},
			label = data.label || "";
		return (
			<div className="facebook-login-button">
				<div className="facebook-login-button" onClick={this.handleOnclickLoginBtn}><FbIconLg />{label}</div>
			</div>
		);
	}
}

export default FacebookLoginStateless;
